import * as React from "react";
import CommonInput from "../input";
import theme from "../../theme";
import { makeStyles } from "@material-ui/core";
import UserTransactionBoard from "./userTransactionsBoard";
import UserDetailsResultBoard from "./userDetailsResultBoard";
import { getEmployeeListAction } from "../../containers/dashboard/action";
import { useDispatch, useSelector } from "react-redux";
import { hasMoney } from "../../lib/permissions";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    fontFamily: theme.fontFamily.MARKPRO,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "200px",
    overflowX: "hidden"
  },
  searchTab: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    width: "100%",
    justifyItems: "space-between"
  }
}))

export default function GeneralStaffOverview() {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [staff, setStaff] = React.useState(null); // current User Details Clicked
  const [searchFilters, setSearchFilters] = React.useState({ page_size: 2, page: 1 });
  const classes = useStyles()
  const dispatch = useDispatch();
  const dashboardReducer = useSelector((selector) => selector?.dashboardReducer)
  const me = useSelector((selector) => selector?.loginReducer?.me)
  let _storedUser = null;
  try {
    _storedUser = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    _storedUser = null;
  }
  // Money transactions board hides without financials.view (staff search stays).
  const canSeeMoney = hasMoney(me || _storedUser);

  // Debounce the typed term and commit it to the filters (reset to page 1).
  // No term -> we don't touch the filters, so no search fires.
  React.useEffect(() => {
    const term = searchTerm.trim();
    if (!term) return undefined;
    const handle = setTimeout(() => {
      setSearchFilters((state) => ({ ...state, search: term, page: 1 }));
    }, 400);
    return () => clearTimeout(handle);
  }, [searchTerm]);

  // Fetch whenever the filters change and a search term is present.
  React.useEffect(() => {
    if (searchFilters.search) {
      dispatch(getEmployeeListAction(searchFilters));
      setStaff(null);
    }
  }, [searchFilters, dispatch])

  const trimmed = searchTerm.trim();
  const users = dashboardReducer?.employeeList?.data || [];
  // Only show results while there is a search term AND matches exist.
  const showResults = !!trimmed && users.length > 0;

  return (
    <section className={classes.root}>
      {dashboardReducer?.error?.length ? (
        <div className={"error-container"}>
          {Array.isArray(dashboardReducer.error) &&
            dashboardReducer.error.map((each, index) => (
              <div key={index}>{each}</div>
            ))}
        </div>
      ) : null}
      <div className={classes.searchTab}>
        <CommonInput
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value)
          }}
          placeholder={"Search By Employee Name, last name, first name, employee code"}
        />
      </div>
      {showResults && (
        <UserDetailsResultBoard
          users={users}
          onRowClick={(each, rowIndex) => {
            setStaff({ userId: each?.id, userName: `${each?.first_name} ${each.last_name}` })
          }}
          totalUsers={dashboardReducer?.employeeList?.count}
          setSearchFilters={setSearchFilters}
          searchFilters={searchFilters}
        />)}
      {canSeeMoney && trimmed && staff?.userId && <UserTransactionBoard {...staff} />}

    </section >
  )
}
